import './index.css';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { ReactComponent as JayapranaLogo } from '@/assets/icons/jayaprana-logo.svg';
import { ReactComponent as ArrowLeftLine } from '@/assets/icons/arrow-left-line.svg';
import Button from '@/components/common/Button';
import Input from '@/components/common/Input';
import { useAppDispatch } from '@/store';
import { forgotPassword } from '@/store/password/action';

const renderModalForm = ({ methods }, onSubmit, navigate, buttonState) => (
	<div className="flex flex-col items-start flex-grow p-10 gap-8 h-full">
		<div className="flex flex-col items-start p-0 gap-1"
				 role="button"
				 tabIndex={0}
				 onKeyDown={() => {}}
				 onClick={() => { navigate(-1) }}>
			<ArrowLeftLine/>
		</div>
		<div className="flex flex-col p-0 gap-1">
			<p className="font-bold text-2xl">Forgot Password</p>
			<p className="text-sm text-grey-dark">Enter your email, we will send you a link to reset your password</p>
		</div>
		<FormProvider {...methods}>
			<form
				className="forgot-password__modal-form__body"
				onSubmit={methods.handleSubmit(onSubmit)}
			>
				<div className="forgot-password__modal-form__body-input">
					<Input
						name="email"
						label="Username / E-mail"
						type="text"
						expanded
						placeholder="Enter your e-mail"
						validationSchema={{ required: 'Please fill me' }}
					/>
				</div>
				<div className="forgot-password__modal-form__body-cta">
					{/* TODO: check preflight overwriting button's bg-color to transparent - btn-primary passed from parent for now */}
					<Button type={buttonState ? null : 'submit'} variant='primary' className={`w-full ${buttonState ? 'btn-disabled cursor-not-allowed' : ''}` } disabled={buttonState}>
						SUBMIT
					</Button>
				</div>
			</form>
		</FormProvider>
	</div>
);

const ForgotPassword = (): JSX.Element => {
	const methods = useForm();
	const navigate = useNavigate();
	const [buttonState, setButtonState] = useState(false)

	const dispatch = useAppDispatch();

	const onSubmit = async () => {
		setButtonState(true)
		const { email } = methods.getValues();
		try {
			await dispatch(forgotPassword(email)).then((res: {[key: string]: any}) => {
				if (res.error) {
					setButtonState(false)
					toast.error('Something went wrong')
					//	TODO: Show toast fail or smth to indicate failure sending email
				} else {
					toast.success('A link has been sent to your email')
					setButtonState(true)
				}
			})
		} catch (e) {
			//TODO
		}
	};

	return (
		<div className="bg-black-primary w-full h-full">
			<div className="mix-blend-overlay opacity-75 absolute bg-[length:100%_100%] bg-[right_bottom_-4%] w-full h-full z-0 forgot-password__overlay" />
			<div className="w-full h-full flex flex-col justify-center items-center relative">
				<div className="mb-12 text-white">
					<JayapranaLogo />
				</div>
				<div className="flex flex-row items-center self-center p-0 gap-3 rounded-md bg-white min-h-[40%] min-w-[20%]">
					{renderModalForm({ methods }, onSubmit, navigate, buttonState)}
				</div>
			</div>
		</div>
	);
};

export default ForgotPassword;
